const userTitles = [
  'Mr',
  'Ms',
];

export default userTitles;



// WEBPACK FOOTER //
// ./src/config/userTitles.js